import React from "react";
import { FiPhone, FiMail, FiMapPin } from "react-icons/fi";
import { useTranslation } from "react-i18next";

export default function ContactInfo() {
  const { t } = useTranslation();
  return (
    <section className="max-w-6xl mx-auto grid md:grid-cols-3 bg-[#f2f8f2] px-6 py-12 mt-[70px] divide-x divide-gray-300">
      {/* Call Us */}
      <div className="flex flex-col items-center text-center px-6">
        <FiPhone className="text-green-700 text-2xl mb-3" />
        <h3 className="text-xl font-semibold">{t("contact.callUs")}</h3>
        <p className="font-arya mt-2 text-green-800 font-medium">
          +45 70 77 70 30
        </p>
      </div>

      {/* Mail Us */}
      <div className="flex flex-col items-center text-center px-6">
        <FiMail className="text-green-700 text-2xl mb-3" />
        <h3 className="text-xl font-semibold">{t("contact.mailUs")}</h3>
        <p className="font-arya mt-2 text-green-800 font-medium">
          Info@asseteye.ai
        </p>
      </div>

      {/* Our Office */}
      <div className="flex flex-col items-center text-center px-6">
        <FiMapPin className="text-green-700 text-2xl mb-3" />
        <h3 className="text-xl font-semibold">{t("contact.ourOffice")}</h3>
        <p className="font-arya mt-2 text-green-800 font-medium">
          Ringager 28, 2605 Brøndby
        </p>
      </div>
    </section>
  );
}
